module.exports = __webpack_public_path__ + "img/offline.f617c565.svg";